// extracted by mini-css-extract-plugin
export var borderImage = "styles-module--borderImage--9874b";
export var borderSpan = "styles-module--borderSpan--c485d";
export var rowItems = "styles-module--rowItems--2af6b";
export var useCaseSection = "styles-module--useCaseSection--dc48a";